import { render } from "./performance-page.vue?vue&type=template&id=4da9cbe9&scoped=true"
import script from "./performance-page.vue?vue&type=script&lang=js"
export * from "./performance-page.vue?vue&type=script&lang=js"

import "./performance-page.vue?vue&type=style&index=0&id=4da9cbe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da9cbe9"]])

export default __exports__